module.exports = __webpack_public_path__ + "static/media/Elitmagistern.86ac4322.png";